import { useEffect, useRef } from "react";
import * as THREE from "three";
import { STLLoader } from "three/examples/jsm/loaders/STLLoader.js";

export const StlViewer = ({ url }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const width = el.clientWidth || 600;
    const height = 360;

    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0x05050a);
    const camera = new THREE.PerspectiveCamera(50, width / height, 0.1, 5000);
    camera.position.set(0, 0, 120);

    const renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(width, height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    el.appendChild(renderer.domElement);

    const l1 = new THREE.DirectionalLight(0x00f0ff, 2.4); l1.position.set(1, 1, 1); scene.add(l1);
    const l2 = new THREE.DirectionalLight(0xff007f, 1.6); l2.position.set(-1, -1, 0.5); scene.add(l2);
    scene.add(new THREE.AmbientLight(0xffffff, 0.45));

    let mesh = null;
    let raf = 0;

    const loader = new STLLoader();
    loader.load(
      url,
      (geo) => {
        geo.center();
        geo.computeBoundingBox();
        const size = new THREE.Vector3();
        geo.boundingBox.getSize(size);
        const maxDim = Math.max(size.x, size.y, size.z) || 1;
        const mat = new THREE.MeshPhongMaterial({ color: 0xbfe9ff, specular: 0x00f0ff, shininess: 70, flatShading: false });
        mesh = new THREE.Mesh(geo, mat);
        mesh.scale.setScalar(60 / maxDim);
        mesh.rotation.x = -Math.PI / 2;
        scene.add(mesh);
      },
      undefined,
      () => {}
    );

    const animate = () => {
      raf = requestAnimationFrame(animate);
      if (mesh) mesh.rotation.z += 0.012;
      renderer.render(scene, camera);
    };
    animate();

    const onResize = () => {
      const w = el.clientWidth || width;
      renderer.setSize(w, height);
      camera.aspect = w / height;
      camera.updateProjectionMatrix();
    };
    window.addEventListener("resize", onResize);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", onResize);
      if (mesh) { mesh.geometry.dispose(); mesh.material.dispose(); }
      renderer.dispose();
      if (el.contains(renderer.domElement)) el.removeChild(renderer.domElement);
    };
  }, [url]);

  return <div ref={ref} data-testid="stl-viewer" className="w-full rounded-sm overflow-hidden border border-white/10" style={{ height: 360 }} />;
};
